import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";
import { GetAgentCommissionTransactions } from "../../../../Services";
import CommissionTableHeaderData from "./CommissionTableHeaderData";
import {
  CustomPagination,
  TableSkeleton,
  CustomExpandableTable,
} from "../../../../Components";
import CommissionTableActions from "./CommissionTableActions/CommissionTableActions";
import AgentCommissionExpandedContent from "../AgentCommissionExpandedContent/AgentCommissionExpandedContent";

import useStyles from "./styles";

export default function CommissionTable({
  isExpanded,
  agentId,
  onOpenSideMenu,
  refetch,
  params = {},
}) {
  const { isDarkMode } = useSelector((state) => state.theme);
  const styles = useStyles({ isDarkMode });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    itemsPerPage: 25,
  });
  const [inputValue, setInputValue] = useState(1);
  const [expandedNestedRowsIds, setExpandedNestedRowsIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    result: [],
    totalCount: 0,
  });
  const getAgentTransactions = async () => {
    setLoading(true);
    const response = await GetAgentCommissionTransactions({
      ...params,
      agentId,
      pageIndex: pagination.currentPage,
      pageSize: pagination.itemsPerPage,
    });
    if (response?.result) {
      setData({
        result: response?.result || [],
        totalCount: response.totalCount || 0,
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isExpanded) {
      getAgentTransactions();
    }
  }, [
    isExpanded,
    pagination.currentPage,
    pagination.itemsPerPage,
    agentId,
    refetch,
  ]);

  return (
    <Box className={styles.root}>
      {loading && <TableSkeleton />}
      {!loading && data.result.length > 0 && (
        <>
          <CustomExpandableTable
            tableActions={({ row, onExpand }) => (
              <CommissionTableActions
                onExpand={() => {
                  if (expandedNestedRowsIds.includes(row.id)) {
                    setExpandedNestedRowsIds(
                      expandedNestedRowsIds.filter((id) => id !== row.id)
                    );
                  } else {
                    setExpandedNestedRowsIds([
                      ...expandedNestedRowsIds,
                      row.id,
                    ]);
                  }
                  onExpand(row);
                }}
                row={row}
                isExpanded={expandedNestedRowsIds.includes(row.id)}
                onMenuOpen={() => {
                  onOpenSideMenu({ ...row, agentId });
                }}
              />
            )}
            data={data.result.map((col, index) => ({
              ...col,
              id: `${col.transactionID}_${index}`,
            }))}
            expandRowContent={(data) => (
              <>
                <AgentCommissionExpandedContent data={data} />
              </>
            )}
            headerData={CommissionTableHeaderData({ isDarkMode })}
            loading={loading}
          />
        </>
      )}

      <CustomPagination
        totalItems={data.totalCount}
        itemsPerPage={pagination.itemsPerPage}
        currentPage={pagination.currentPage}
        inputValue={inputValue}
        setInputValue={setInputValue}
        isLoading={loading}
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, currentPage: page }))
        }
        onItemsPerPageChange={(items) =>
          setPagination((prev) => ({ ...prev, itemsPerPage: items }))
        }
      />
    </Box>
  );
}
